import * as Sentry from "@sentry/browser";
import { createRoot } from "react-dom/client";

import { datadogRum } from "@datadog/browser-rum";

import App from "./App";
import { DeploymentEnvironmentConstants } from "./shared/constants";
import { DocumentTitleContext, DocumentTitleContextProvider } from "@app/shared/DocumentTitleContext";

// Enable Sentry for non-development environments.
if (process.env.NODE_ENV !== "development") {
  Sentry.init({
    dsn: "https://34092f8ac62c43f88e47f2b7eb9c8876@sentry.io/1369074", // There is only ever one value for this, it doesn't vary by environment.

    // Purposely filter out __ENVIRONMENT__ and __RELEASE_ENVIRONMENT__ to keep things clean if someone forgets to set a configuration value.
    environment:
      window.environment && !["__ENVIRONMENT__", "__RELEASE_ENVIRONMENT__"].find((s) => s === window.environment)
        ? window.environment
        : DeploymentEnvironmentConstants.Local,

    release: window.sourceVersion || undefined,
  });
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <DocumentTitleContextProvider>
    <DocumentTitleContext.Consumer>
      {({ title }) => (
        <>
          {/* 
            We're relying on React 19's title tag hoisting. It doesn't account for duplicate title tags,
            which means this should be the only place in QES where <title> is defined (outside <svg> tags,
            where <title> is semantically different and React ignores it). 
            https://react.dev/reference/react-dom/components/title
          */}
          <title>{title}</title>
          <App />
        </>
      )}
    </DocumentTitleContext.Consumer>
  </DocumentTitleContextProvider>
);

if (process.env.NODE_ENV !== "development") {
  datadogRum.init({
    applicationId: window.datadogAppId,
    clientToken: window.datadogClientToken,
    env: window.environment,
    sessionSampleRate: 100,
    site: "datadoghq.com",
    trackUserInteractions: true,
    trackViewsManually: true,
    version: window.buildVersion,
  });
}

if (module.hot) {
  module.hot.accept("./App", () => {
    root.render(<App />);
  });
}
